import { useMemo } from "react";
import type { ColumnCatalog, ColumnOption } from "@/components/application/table/column-layout";

const GROUPS = ["Sales", "Funnel", "Output", "Audience", "Commerce profile", "Activity", "Safety"];

const OPTIONS: ColumnOption[] = [
  { id: "matchQualityScore", group: "Audience", lock: "pinned" },
  { id: "cohort", group: "Activity", lock: "unhideable" },
  { id: "gmv", group: "Sales" },
  { id: "avgGmv", group: "Sales" },
  { id: "orders", group: "Sales" },
  { id: "ordersPerWeek", group: "Sales" },
  { id: "revenue", group: "Sales" },
  { id: "gpm", group: "Sales" },
  { id: "aov", group: "Sales" },
  { id: "unitSales", group: "Sales" },
  { id: "lastSale", group: "Sales" },
  { id: "ctr", group: "Funnel" },
  { id: "ctor", group: "Funnel" },
  { id: "videos", group: "Output" },
  { id: "postsPerWeek", group: "Output" },
  { id: "avgVideosPerMonth", group: "Output" },
  { id: "postingFrequency", group: "Output" },
  { id: "topGender", group: "Audience" },
  { id: "topAgeRange", group: "Audience" },
  { id: "followerCount", group: "Audience" },
  { id: "avgLikesPerVideo", group: "Audience" },
  { id: "network", group: "Audience" },
  { id: "topCategories", group: "Commerce profile" },
  { id: "topProduct", group: "Commerce profile" },
  { id: "avgCommissionRate", group: "Commerce profile" },
  { id: "sellerRating", group: "Commerce profile" },
  { id: "campaigns", group: "Activity" },
  { id: "lastActivity", group: "Activity" },
  { id: "lastContacted", group: "Activity" },
  { id: "videosWithRisks", group: "Safety" },
  { id: "commonViolations", group: "Safety" },
];

const TAGS_OPTION: ColumnOption = { id: "tags", group: "Activity" };

const DEFAULTS = [
  "matchQualityScore",
  "tags",
  "cohort",
  "network",
  "gmv",
  "topGender",
  "topAgeRange",
  "videos",
  "followerCount",
];

export const useCreatorColumnCatalog = ({ creatorTagsEnabled }: { creatorTagsEnabled: boolean }): ColumnCatalog =>
  useMemo(() => {
    const options = creatorTagsEnabled ? [...OPTIONS, TAGS_OPTION] : OPTIONS;
    const ids = new Set(options.map((option) => option.id));
    return { tableKey: "creators", options, defaults: DEFAULTS.filter((id) => ids.has(id)), groups: GROUPS };
  }, [creatorTagsEnabled]);
